module.exports = __webpack_public_path__ + "img/merchant.0fbfbdda.svg";